import { useEffect, useState } from "react";
import { calculateDistance } from "shared/utils";

export const useCalculateDistance = (
  startingCoordinates?: [number, number],
  targetCoordinates?: [number, number],
) => {
  const [distance, setDistance] = useState(0);
  const [duration, setDuration] = useState(0);

  useEffect(() => {
    if (startingCoordinates && targetCoordinates) {
      const calculate = async () => {
        const result = await calculateDistance(
          startingCoordinates,
          targetCoordinates,
        );
        setDistance(result.distance);
        setDuration(result.duration);
      };
      calculate();
    }
  }, [startingCoordinates, targetCoordinates]);

  return {
    distance,
    duration,
  };
};
